import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectLeaguePoints, selectTournamentRewardIndex, selectTournamentRewards, } from "../../selectors/selectTournamentInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { EventThresholdSelectedContainer } from "../generic/common/EventThresholdSelectedContainer";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { ProgressBar } from "../generic/progress-bar/ProgressBar";
import { TextLoca } from "../generic/text/TextLoca";
import { EventRewards } from "./EventRewards";
var EventThresholdInformationDOM = function (_a) {
    var currentPoints = _a.currentPoints, rewards = _a.rewards, selectedRewardIndex = _a.selectedRewardIndex;
    var maxPoints = rewards[rewards.length - 1].requiredThreshold;
    var areThresholdsCompleted = currentPoints.gt(maxPoints);
    var thresholdPercent = areThresholdsCompleted
        ? 100
        : calculateTresholdPercentage(currentPoints, rewards, selectedRewardIndex);
    var progressBarText;
    if (areThresholdsCompleted) {
        progressBarText = (React.createElement("span", null,
            React.createElement(TextLoca, { id: IdLoca.points, className: IdStyles.TextNormal }),
            "\u00A0",
            React.createElement(NumberFormat, { className: IdStyles.TextNormal, amount: currentPoints })));
    }
    else {
        var selectedRewardThreshold = rewards[selectedRewardIndex].requiredThreshold;
        var locaReplacements = new Map([
            [ReplacementLoca.zero_0, utilNumber.format(currentPoints)],
            [ReplacementLoca.one_1, utilNumber.format(selectedRewardThreshold)],
        ]);
        progressBarText = (React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.pointsX_of_Y, replacements: locaReplacements }));
    }
    return (React.createElement("div", { className: "tournament-info__threshold-info" },
        React.createElement("div", { className: IdStyles.TextBoldAccent },
            React.createElement(TextLoca, { id: IdLoca.rewards })),
        React.createElement("div", null,
            React.createElement(EventRewards, { rewards: rewards, currentPoints: currentPoints }),
            React.createElement(EventThresholdSelectedContainer, null,
                React.createElement("div", { className: "flex flex--guts h100" },
                    React.createElement(ProgressBar, { backgroundClassName: IdStyles.TournamentThresholdProgressBarBackground, progressPercent: thresholdPercent, fillClassName: IdStyles.TournamentThresholdProgressBarFill }, progressBarText))))));
};
var calculateTresholdPercentage = function (currentPoints, rewards, selectedRewardIndex) {
    var currentTreshold = rewards[selectedRewardIndex].requiredThreshold;
    var previousTreshold = selectedRewardIndex === 0 ? 0 : rewards[selectedRewardIndex - 1].requiredThreshold;
    return currentPoints
        .subtract(previousTreshold)
        .multiply(100)
        .divide(currentTreshold - previousTreshold)
        .toNumber();
};
var mapState = function (state) { return ({
    currentPoints: selectLeaguePoints(state),
    rewards: selectTournamentRewards(state),
    selectedRewardIndex: selectTournamentRewardIndex(state),
}); };
export var EventThresholdInformation = connect(mapState)(EventThresholdInformationDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/EventThresholdInformation.tsx
// module id = 2775
// module chunks = 3